import { render, staticRenderFns } from "./SearchSuggesterBar.vue?vue&type=template&id=37396092"
import script from "./SearchSuggesterBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchSuggesterBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchSuggesterBar.vue?vue&type=style&index=0&id=37396092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports